import React from 'react'
import styles from "../../../Styles/ComponentStyles/GlobalComponentStyles/SideNavigationPanel.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

import Grid from '@mui/material/Grid2';
import { List, ListItem, Typography, Tooltip } from '@mui/material';

const ModuleList = (props: any) => {
    const { menuItems, isProfileAdmin, handleNavigate, currentSelectedTab, drawerOpen, mobileOpen } = props;


    return (
        <List className={`${styles.navigationList}`}>
            {menuItems?.filter((item: any) => item?.roles?.includes(isProfileAdmin ? "admin" : "user"))?.map((item: any) => {
                const isSelected = currentSelectedTab === item.name;
                const showText = drawerOpen || mobileOpen;

                const iconElement = (
                    <div>
                        {isSelected ? item.selectedIcon : item.icon}
                    </div>
                );

                const listItemContent = (
                    <ListItem
                        key={item.name}
                        onClick={() => {
                            if (item.onClick) {
                                item.onClick();
                            } else {
                                handleNavigate(item.path!, item.name);
                            }
                        }}
                        className={
                            item.name === 'Dashboard' ? `${styles.sideNavigationFirstElement}` : (item.name === 'Profile' || item.name === 'Logout' ? `${styles.sideNavigationListProfile}` : `${styles.sideNavigationList}`)
                        }
                        sx={{
                            backgroundColor: isSelected ? "#ffffff" : "transparent",
                            color: isSelected ? "#000000" : "#ffffff",
                        }}
                    >
                        <Grid size={{ xs: 12 }}>
                            <Grid container sx={{ gap: showText ? "15px" : "0", justifyContent: 'center' }}>
                                <Grid className={`${styles.sideNavigationNameIcon}`}>
                                    {iconElement}
                                </Grid>
                                <Grid className={`${styles.sideNavigationName}`}>
                                    {showText && (
                                        <Typography component='span'>
                                            {item.name}
                                        </Typography>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </ListItem>
                );

                return showText ? listItemContent : (
                    <Tooltip
                        key={item.name}
                        title={item.name}
                        placement="right"
                        arrow
                        PopperProps={{ className: styles.sideNavigationTooltip }}
                    >
                        <div>{listItemContent}</div>
                    </Tooltip>
                );
            })}
        </List>
    );
};

export default ModuleList;







// import React from 'react'
// import styles from "../../../Styles/ComponentStyles/GlobalComponentStyles/SideNavigationPanel.module.scss"
// import globalStyles from "../../../Styles/global.module.scss"
// import Grid from '@mui/material/Grid2';
// import { List, ListItem, Typography } from '@mui/material'

// const ModuleList = (props: any) => {

//     const { menuItems, isProfileAdmin, handleNavigate, currentSelectedTab, drawerOpen, mobileOpen } = props

//     return (
//         <>
//             <List className={`${styles.navigationList}`}>
//                 {menuItems && menuItems?.filter((item: any) => item?.roles?.includes(isProfileAdmin ? "admin" : "user"))?.map((item: any) => (
//                     <ListItem
//                         key={item.name}
//                         onClick={() => {
//                             if (item.onClick) {
//                                 item.onClick();
//                             } else {
//                                 handleNavigate(item.path);
//                             }
//                         }}
//                         className={item.name === 'Dashboard' ? `${styles.sideNavigationFirstElement}` : (item.name === 'Profile' || item.name === 'Logout' ? `${styles.sideNavigationListProfile}` : `${styles.sideNavigationList}`)}
//                         sx={{
//                             backgroundColor: currentSelectedTab === item.name ? "#ffffff" : "transparent",
//                             color: currentSelectedTab === item.name ? "#000000" : "#ffffff",
//                         }}
//                     >
//                         <Grid size={{ xs: 12 }}>
//                             <Grid container sx={{ gap: (drawerOpen || mobileOpen) ? "15px" : "0", justifyContent: 'center' }}>
//                                 <Grid className={`${styles.sideNavigationNameIcon}`}>
//                                     <div>
//                                         {currentSelectedTab === item.name ? item.selectedIcon : item.icon}
//                                     </div>
//                                 </Grid>
//                                 <Grid className={`${styles.sideNavigationName}`}>
//                                     {(drawerOpen || mobileOpen) ? (
//                                         <Typography component='span'>
//                                             {item.name}
//                                         </Typography>
//                                     ) : (<></>)
//                                     }
//                                 </Grid>
//                             </Grid>
//                         </Grid>
//                     </ListItem>
//                 ))}
//             </List>
//         </>
//     )
// }
// export default ModuleList